import React from 'react';
import SearchSelect from './SearchSelect';
import { listAccessUsers } from '../api/access';

/**
 * 平台用户选择器 (2026-09-12): 只能从 rbac_user 里选, 不能手敲邮箱 —— 权限分配 / 角色成员添加共用.
 * 异步搜索走 /v1/access/users?keyword= (邮箱 / 显示名模糊); value = 邮箱 (小写).
 */
const PAGE = 20;

function UserPicker({
    value,
    onChange,
    className,
    placeholder = '搜索用户 (邮箱 / 显示名)',
}: {
    value: string;
    onChange: (email: string) => void;
    className?: string;
    placeholder?: string;
}) {
    return (
        <SearchSelect
            className={className || 'w-72'}
            value={value}
            placeholder={placeholder}
            clearable
            onChange={(v) => onChange(v)}
            loadOptions={async (query, page) => {
                const res = await listAccessUsers({ keyword: query || undefined, page, pageSize: PAGE });
                const list = (res.list || [])
                    .filter((u) => u.email)
                    .map((u) => ({
                        value: u.email,
                        label: u.displayName ? `${u.displayName} <${u.email}>` : u.email,
                    }));
                return { list, hasMore: page * PAGE < res.totalCount };
            }}
        />
    );
}

export default UserPicker;
